import React from 'react';
import styled from 'styled-components';
import Button from '../commons/component/button';
import { createSendEmailRequest } from '../api/customer/send-email';
import axios from 'axios';

export default class DescadastroEmailComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'idle'
    };

    this.doDescadastroEmail = this.doDescadastroEmail.bind(this);
  }

  async doDescadastroEmail(email) {
    this.setState({ status: 'loading' });
    try {
      var request = createSendEmailRequest(email, 'optOut');
      const { data } = await axios(request);

      this.setState({ status: 'success', data });
    } catch (error) {
      console.error(error);
      this.setState({ status: 'error', error });
    }
  }

  render() {
    const urlParams = new URLSearchParams(this.props.location.search);

    return (
      <div className="entrar__wrapper">
        <Description>
          Você confirma o <b>cancelamento</b> de sua inscrição?
        </Description>
        <DescadastroButton
          primary
          disabled={this.state.status === 'loading'}
          loading={this.state.status === 'loading'}
          onClick={() => this.doDescadastroEmail(urlParams.get('email'))}
        >
          Confirmo
        </DescadastroButton>
        {this.state.status === 'error' && (
          <ErrorMessage>Não foi possível enviar sua solicitação de cancelamento.</ErrorMessage>
        )}
        {this.state.status === 'success' && (
          <SuccessMessage>Acesse seu e-mail para confirmar o cancelamento.</SuccessMessage>
        )}
      </div>
    );
  }
}

const Description = styled.p`
  color: #666;
  text-align: center;
  font-size: 18px;
`;

const DescadastroButton = styled(Button)`
  margin: 0 auto;
  display: block;
`;

const ErrorMessage = styled.p`
  color: red;
  text-align: center;
  margin-top: 15px;
`;

const SuccessMessage = styled.p`
  color: green;
  text-align: center;
  margin-top: 15px;
`;
